import _ from 'lodash'

export default class BlackBoxSemanal{
    constructor(){
        this.lista = []
        this.filtroFacturables = []
        this.filtroFechas = []
        this.filtroCeco = []
        this.filtroRegiones = []
        this.filtroComunas = []
        this.filtroAuditores = []
        this.filtroFechaAuditoria = []
        this.filtroClientes = []
        this.filtroLink = []
        this.filtroDescargaIrd = []
        this.filtroSuspendidos = []
        this.filtroObservaciones = []
        this.filtroObservacionesCliente = []
        this.filtroZip = []
        this.filtroResultado = []
        this.filtroMuestraO = []
        this.filtroMuestraD = []
        this.filtroSensores = []
    }
    reset() {
        this.lista = []
        this.filtroFacturables = []
        this.filtroFechas = []
        this.filtroCeco = []
        this.filtroRegiones = []
        this.filtroComunas = []
        this.filtroAuditores = []
        this.filtroFechaAuditoria = []
        this.filtroClientes = []
        this.filtroLink = []
        this.filtroDescargaIrd = []
        this.filtroSuspendidos = []
        this.filtroObservaciones = []
        this.filtroObservacionesCliente = []
        this.filtroZip = []
        this.filtroResultado = []
        this.filtroMuestraO = []
        this.filtroMuestraD = []
        this.filtroSensores = []
    }
    // Todo: Optimizar
    // Todo Modificar: el listado de clientes
    add(auditoria){
        this.lista.push(auditoria)
    }
    remove(idAuditoria){
        let index = this.lista.findIndex(auditoria=>auditoria.idAuditoria===idAuditoria)
        if(index>=0) this.lista.splice(index, 1)
    }

    // Todo modificar el listado de clientes
    // actualizarAuditoria(auditoriaActualizada){
    //     this.lista = this.lista.map(auditoria=> {
    //         if (auditoria.aud_idAuditoria == auditoriaActualizada.aud_idAuditoria) {
    //             //auditoria = Object.assign(auditoria, auditoriaActualizada)
    //             console.log(auditoriaActualizada)
    //             auditoriaActualizada.aud_idAuditoriaOriginal = 0
    //             return auditoriaActualizada
    //         }
    //         // Si tiene hay una auditoria de sensores vinculada, se actualiza
    //         if((auditoria.aud_idAuditoriaOriginal == auditoriaActualizada.aud_idAuditoria) && auditoria.aud_fechaProgramada !== auditoriaActualizada.aud_fechaProgramada){
    //             auditoria = {
    //                 ...auditoria,
    //                 aud_fechaProgramada: auditoriaActualizada.aud_fechaProgramada,
    //                 aud_fechaProgramadaDOW: auditoriaActualizada.aud_fechaProgramadaDOW,
    //                 aud_fechaProgramadaF: auditoriaActualizada.aud_fechaProgramadaF,
    //                 aud_fechaProgramadaFbreve: auditoriaActualizada.aud_fechaProgramadaFbreve,
    //             }
    //             return auditoria
    //         }

    //         return auditoria
    //     })
    //     // una vez que se realizaron los cambios del inventario, se actualizan los filtros
    //     this.actualizarFiltros()
    // }
    actualizarAuditoria(auditoriaActualizada){
        this.lista = this.lista.map(auditoria=> {
            if (auditoria.aud_idAuditoria == auditoriaActualizada.aud_idAuditoria) {
                //auditoria = Object.assign(auditoria, auditoriaActualizada)
                return auditoriaActualizada
            }
            return auditoria
        })
        // una vez que se realizaron los cambios del inventario, se actualizan los filtros
        this.actualizarFiltros()
    }

    /*** ################### FILTROS ################### ***/

    ordenarLista(){
        let porFechaProgramada = (auditoria)=>{
            let dateA = new Date(auditoria.aud_fechaProgramada)
            if(dateA=='Invalid Date'){
                let [annoA, mesA, diaA] = auditoria.aud_fechaProgramada.split('-')
                // OJO: (new Date('2016-04')) - (new Date('2016-03-31')), resulta en 0, y los ordena mal, por eso se resta 1
                return new Date(`${annoA}-${mesA}`) - 1
            }else{
                return dateA
            }
        }
        let porAuditor = (auditoria)=>{
            return auditoria.aud_auditor
        }
        let porComuna = (auditoria)=>auditoria.local_cutComuna

        // ordenar por fechaprogramada, por auditor, y finalmente por comuna
        this.lista = _.sortBy(this.lista, porFechaProgramada, porAuditor, porComuna)
    }

    actualizarFiltros(){
        // ##### Filtro Facturables
        this.filtroFacturables = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_facturable
                let texto = auditoria.aud_facturable == 1 ? 'Facturable' : 'No Facturable'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroFacturables, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()

        // ##### Filtro fechas
        this.filtroFechas = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_fechaProgramada
                let texto = auditoria.aud_fechaProgramadaFbreve

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroFechas, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        // ###### Filtro CLIENTES
        this.filtroClientes = _.chain(this.lista)
            .map(inventario=>{
                let valor = inventario.cliente_idCliente
                let texto = inventario.cliente_nombreCorto

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroClientes, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')    // ordenado por numero de cliente
            .value()

        // ##### Filtro CECO (ordenado por numero)
        this.filtroCeco = _.chain(this.lista)
            .map(auditoria=>{
                let valor = ''+auditoria.local_ceco
                let texto = ''+auditoria.local_ceco

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroCeco, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .sortBy((ob)=>ob.valor.length, 'valor') // ordenar primero los numeros de dos digitos, luego los de 3 digitos...
            .value()

        // ##### Filtro Regiones (ordenado por codRegion)
        this.filtroRegiones = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.local_cutRegion
                let texto = auditoria.local_region

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroRegiones, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')    // ordenado por numero de region
            .value()

        // ##### Filtro Comunas (ordenado por codComuna)
        this.filtroComunas = _.chain(this.lista)
            // solo dejar las comunas en las que su respectiva region este seleccionada
            .filter(auditoria=>{
                return _.find(this.filtroRegiones, {'valor': auditoria.local_cutRegion, 'seleccionado': true})
            })
            .map(auditoria=>{
                let valor = auditoria.local_cutComuna
                let texto = auditoria.local_comuna

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroComunas, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Auditores
        this.filtroAuditores = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_idAuditor
                let texto = auditoria.aud_auditor

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroAuditores, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('texto')
            .value()

        // ##### Filtro Fecha Auditoria
        this.filtroFechaAuditoria = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_fechaAuditoria
                let texto = auditoria.aud_fechaAuditoria==='0000-00-00'? 'PENDIENTE' : auditoria.aud_fechaAuditoria

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroFechaAuditoria, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        
        // ##### Filtro Link ejecutado
        this.filtroLink = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_linkEjecutado
                let texto = auditoria.aud_linkEjecutado? 'Ejecutado' : 'No Ejecutado'
                let opcion = _.find(this.filtroLink, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()

         // ##### Filtro Descargar IRD
         this.filtroDescargaIrd = _.chain(this.lista)
         .map(auditoria=>{
             let valor = auditoria.aud_descarga_ird
             let texto = auditoria.aud_descarga_ird > 0 ? 'SI' : 'NO'
             let opcion = _.find(this.filtroDescargaIrd, {'valor': valor})
             return opcion? opcion : {valor, texto, seleccionado: true}
         })
         .uniqBy('valor')
         .sortBy('valor')
         .value()

        // ##### Filtro Observaciones
        this.filtroObservaciones = _.chain(this.lista)
            .map(auditoria=>{
                let valor = ''+auditoria.aud_observacion
                let texto = ''+auditoria.aud_observacion

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroObservaciones, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        
        // ##### Filtro Observaciones CLIENTE
        this.filtroObservacionesCliente = _.chain(this.lista)
            .map(auditoria=>{
                let valor = ''+auditoria.aud_observacion_cliente
                let texto = ''+auditoria.aud_observacion_cliente

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroObservacionesCliente, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()

        // ##### Filtro Zip
        this.filtroZip = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_estadoArchivoFinal
                let texto = auditoria.aud_estadoArchivoFinal

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroZip, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            //.sortBy('valor')
            .value()

        // ##### Filtro Resultado
        this.filtroResultado = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_publicado
                let texto = auditoria.aud_publicado? 'Publicado' : 'Por publicar'

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroResultado, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroMuestraO = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_mvencimientoDisponible
                let texto = auditoria.aud_mvencimientoDisponible

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroMuestraO, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroMuestraD = _.chain(this.lista)
            .map(auditoria=>{
                let valor = auditoria.aud_mvencimientoDiferencia
                let texto = auditoria.aud_mvencimientoDiferencia

                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroMuestraD, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
        this.filtroSuspendidos = _.chain([
                {valor:1, texto:'No aplica'},
                {valor:2, texto:'Remodelación'},
                {valor:3, texto:'Falta Personal'},
                {valor:4, texto:'Corte electricidad'},
                {valor:5, texto:'QF suspende'},
                {valor:6, texto:'Auditor no asiste'},
                {valor:9, texto:'Pago 50%'},
                {valor:8, texto:'Fase 2'},
                {valor:10, texto:'Medición especial'},
                {valor:11, texto:'No Pago'},
                {valor:7, texto:'Otro'},
            ])
            .map(item => {
                let {valor, texto} = item;
                let opcion = _.find(this.filtroSuspendidos, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .value();
            this.filtroSensores = _.chain(this.lista)
            .map(auditoria => {
                let valor = auditoria.aud_sensores
                let texto = auditoria.aud_sensores
                let opcion = _.find(this.filtroSensores, { 'valor': valor })
                return opcion ? opcion : { valor, texto, seleccionado: true }
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value(); // ¡Asegúrate de llamar a .value() aquí!        
    }
    reemplazarFiltro(nombreFiltro, filtroActualizado) {
        if(this[nombreFiltro]) {
            this[nombreFiltro] = filtroActualizado
        }else{
            console.error(`Filtro ${nombreFiltro} no existe.`)
        }
    }

    getListaFiltrada(){
        this.actualizarFiltros()
        return {
            auditoriasFiltradas: _.chain(this.lista)
                // Filtrar por cliente
                .filter(auditoria=>{
                    return _.find(this.filtroClientes, {'valor': auditoria.cliente_idCliente, 'seleccionado': true})
                })
                // Filtrar por Facturable
                .filter(auditoria=>{
                    return _.find(this.filtroFacturables, {'valor': auditoria.aud_facturable, 'seleccionado': true})
                })
                // Filtrar por Fecha
                .filter(auditoria=>{
                    return _.find(this.filtroFechas, {'valor': auditoria.aud_fechaProgramada, 'seleccionado': true})
                })
                .filter(auditoria=>{
                    return _.find(this.filtroLink, {'valor': auditoria.aud_linkEjecutado, 'seleccionado': true})
                })
                // Filtrar Descarga Ird
                .filter(auditoria=>{
                    return _.find(this.filtroDescargaIrd, {'valor': auditoria.aud_descarga_ird, 'seleccionado': true})
                })
                .filter(auditoria=>{
                    return _.find(this.filtroClientes, {'valor': auditoria.cliente_idCliente, 'seleccionado': true})
                })
                // Filtrar por Ceco
                .filter(auditoria=>{
                    return _.find(this.filtroCeco, {'valor': ''+auditoria.local_ceco, 'seleccionado': true})
                })
                // Filtrar por Region
                .filter(auditoria=>{
                    return _.find(this.filtroRegiones, {'valor': auditoria.local_cutRegion, 'seleccionado': true})
                })
                // Filtrar por Comuna
                .filter(auditoria=>{
                    return _.find(this.filtroComunas, {'valor': auditoria.local_cutComuna, 'seleccionado': true})
                })
                // Filtrar por Auditor
                .filter(auditoria=>{
                    return _.find(this.filtroAuditores, {'valor': auditoria.aud_idAuditor, 'seleccionado': true})
                })
                // Filtrar por Fecha de Subida de Nomina
                .filter(auditoria=>{
                    return _.find(this.filtroFechaAuditoria, {'valor': auditoria.aud_fechaAuditoria, 'seleccionado': true})
                })
                // Filtrar por observaciones
                .filter(auditoria=>{
                    return _.find(this.filtroObservaciones, {'valor': auditoria.aud_observacion, 'seleccionado': true})
                })
                // Filtrar por observaciones CLIENTE
                .filter(auditoria=>{
                    return _.find(this.filtroObservacionesCliente, {'valor': auditoria.aud_observacion_cliente, 'seleccionado': true})
                })
                // Filtrar por estado zip
                .filter(auditoria=>{
                    return _.find(this.filtroZip, {'valor': auditoria.aud_estadoArchivoFinal, 'seleccionado': true})
                })
                // Filtrar por publicacion vencimiento
                .filter(auditoria=>{
                    return _.find(this.filtroResultado, {'valor': auditoria.aud_publicado, 'seleccionado': true})
                })
                // Filtrar por muestras obligatorias
                .filter(auditoria=>{
                    return _.find(this.filtroMuestraO, {'valor': auditoria.aud_mvencimientoDisponible, 'seleccionado': true})
                })
                // Filtrar por diferencias de muestras
                .filter(auditoria=>{
                    return _.find(this.filtroMuestraD, {'valor': auditoria.aud_mvencimientoDiferencia, 'seleccionado': true})
                })
                //filtro de auditorias vencimientos
                .filter(auditoria=>{
                    return _.find(this.filtroSuspendidos, {'valor': auditoria.aud_suspendida, 'seleccionado': true});
                })
                .filter(auditoria=>{
                    return _.find(this.filtroSensores, {'valor': auditoria.aud_sensores, 'seleccionado': true});
                })
                .value(),
            filtros: {
                filtroFacturables: this.filtroFacturables,
                filtroFechas: this.filtroFechas,
                filtroCeco: this.filtroCeco,
                filtroRegiones: this.filtroRegiones,
                filtroComunas: this.filtroComunas,
                filtroAuditores: this.filtroAuditores,
                filtroFechaAuditoria: this.filtroFechaAuditoria,
                filtroClientes: this.filtroClientes,
                filtroLink: this.filtroLink,
                filtroDescargaIrd: this.filtroDescargaIrd,
                filtroObservaciones: this.filtroObservaciones,
                filtroObservacionesCliente: this.filtroObservacionesCliente,
                filtroZip: this.filtroZip,
                filtroResultado: this.filtroResultado,
                filtroMuestraO: this.filtroMuestraO,
                filtroMuestraD: this.filtroMuestraD,
                filtroSuspendidos: this.filtroSuspendidos,
                filtroSensores: this.filtroSensores
            }
        }
    }
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/BlackBoxSemanal.js